import React from 'react';
import PropTypes from 'prop-types';
import { NO_DATA_FOUND } from '../../../../static/constants.js';
import { messageManager } from '../../../System/messageManager/messageManager.js';
import GeneralEmptyState from '../GeneralEmptyState/GeneralEmptyState.js';
import { buildPath } from '../../../../services/navigateService.js';
import { useNavigate } from 'react-router';
import { useUser } from '../../../../contexts/userContext.js';
import { NAVIGATION_PATHS } from '../../../../static/navigationPaths.js';

const NoResultsEmptyState = ({ nameConventions }) => {
  const { user } = useUser();
  const noResultsText = messageManager(nameConventions).NO_RESULTS_EMPTY_STATE;
  const navigate = useNavigate();

  const handleNavigate = () => {
    const path = buildPath(user, NAVIGATION_PATHS.CONFIGURE_SCORING);
    navigate(path);
  };

  return (
    <GeneralEmptyState
      src={NO_DATA_FOUND.source}
      alt={NO_DATA_FOUND.alt}
      title={noResultsText.NO_RESULTS_FOR_BUDGET_MESSAGE}
      buttonTitle={noResultsText.BUTTON_TEXT}
      handleClick={handleNavigate}
    />
  );
};

NoResultsEmptyState.propTypes = {
  nameConventions: PropTypes.object,
};

export default NoResultsEmptyState;
